import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";

export default function ChatMessagesSkeleton({ isGroup = false, count= isGroup?7: 9}) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => {
          const isMe = Math.random() > 0.5;

        return (
          <Stack
            key={i}
            direction="column"
            alignItems={isMe ? "flex-end" : "flex-start"}
            spacing={0.6}
            sx={{ mb: 1 }}
          >
            {/* Avatar + name (group, left side only) */}
            {!isMe && isGroup && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="text" width={60} height={10} />
              </Box>
            )}

            {/* Message bubble */}
            <Skeleton
              variant="rounded"
              animation="wave"
              width={isMe ? "55%" : "65%"}
              height={32}
              sx={{ borderRadius: 2 }}
            />

            {/* Time */}
            {/* <Skeleton variant="text" width={40} height={8} /> */}
          </Stack>
        );
      })}
    </>
  );
}
